import { useMutation } from '@apollo/client'
import { message } from 'antd'

import MUTATION_DOCUMENT from './loginLine'

import type {
  APIPayloadResponse,
  AuthType,
  GraphQLServiceMutationHook,
  LoginAPIPayload,
} from 'graphQL/graphQL-service-hook'

interface LoginLineData {
  loginLine: APIPayloadResponse<LoginAPIPayload>
}

interface LoginLineVars {
  lineToken: string
  authType: AuthType
  redirectUrl: string
}

const useLoginLine: GraphQLServiceMutationHook<LoginLineData, LoginLineVars> = (options) => {
  return useMutation(MUTATION_DOCUMENT, {
    onError(error) {
      message.error(error.message)
    },
    ...options,
  })
}

export default useLoginLine
